import { toast } from "react-toastify";
import CircularProgress from '@mui/material/CircularProgress';

export const handleSuccess = (msg)=>{
    toast.success(msg, {
        position : 'top-right'
    })
}

export const handleError = (msg)=>{
    toast.error(msg,  {
        position : 'top-right'
    })
}
export const handleInfo= (msg)=>{
    toast.info(msg, {
        position : 'top-right'
    })
}
const CodeQueueSpinner = () => {
  return (
    <div>
        <div className="text-center"><CircularProgress disableShrink /></div>
    </div>
  )
}

export default CodeQueueSpinner